import React, { useState, Fragment } from "react";
import QuestionContainer from "../QuestionContainer/QuestionContainer";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import initialState from "../../../utils/initialState";
import { Grid } from "@material-ui/core";
import { params, shouldRenderButton, shouldRenderInput, SUBCATEGORIES, OPTIONS } from "./parentRules";

export default function ParentForm(props) {
	const { data, handleChange, currentDisplayedForm, handleCurrentDisplayForm, formLevel } = props;
	const { formData, handleFormData, globalFormData } = props;
	const { children, id, label } = data;

	let formCurrentPosition;
	if (label === SUBCATEGORIES) {
		formCurrentPosition = formData?.subCategories || [initialState(children)];
	} else {
		formCurrentPosition = formData?.options || [initialState(children)];
	}
	const [parentAmount, setParentAmount] = useState(formCurrentPosition?.length);
	const iterableMap = [...new Array(parentAmount)];

	const localHandleChange = (e, i, level) => {
		const { name, value, type, checked } = e.target;
		const newValue = type === "checkbox" ? checked : value;
		let formDataNew = [...formCurrentPosition];
		formDataNew[i] = {
			...formDataNew[i],
			[name]: newValue,
		};
		const response = {
			target: {
				name: id,
				value: formDataNew,
			},
		};

		handleChange(response);
	};

	const increaseParentAmount = () => {
		if (label === SUBCATEGORIES) {
			const addedFormData = {
				...formData,
				[label]: [...(formData[label] || [initialState(children)]), initialState(children)],
			};
			handleFormData(addedFormData);
			setParentAmount(parentAmount + 1);
		}

		if (label === OPTIONS) {
			let addedFormData = {
				...globalFormData,
			};
			addedFormData.subCategories[formLevel.position.subCategories] = {
				...formData,
				options: [...formCurrentPosition, initialState(children)],
			};

			handleFormData(addedFormData);
			setParentAmount(parentAmount + 1);
		}
	};

	const decreaseParentAmount = () => {
		if (label === SUBCATEGORIES) {
			if (parentAmount <= 1) return;
			const poppedData = formData[label].slice(0, formData[label].length - 1);
			const addedFormData = {
				...formData,
				[label]: poppedData,
			};
			handleFormData(addedFormData);
			setParentAmount(parentAmount - 1);
		}
		if (label === OPTIONS) {
			if (parentAmount <= 1) return;
			const poppedData = formData["options"].slice(0, formData["options"].length - 1);
			let addedFormData = {
				...globalFormData,
			};
			addedFormData.subCategories[formLevel.position.subCategories] = {
				...formData,
				options: poppedData,
			};

			handleFormData(addedFormData);
			setParentAmount(parentAmount - 1);
		}
	};

	return (
		<>
			{iterableMap.map((_, gIndex) => {
				const currentParams = params(formCurrentPosition ? formCurrentPosition[gIndex]?.name : "", gIndex, id);
				const formLevelCheck = formLevel?.position || {};
				const level = {
					level: formLevel.level + 1,
					subLevel: gIndex,
					position: { [label]: gIndex, ...formLevelCheck },
				};
				const isSameLevel =
					currentDisplayedForm.level === level.level && currentDisplayedForm.subLevel === level.subLevel;
				const buttonLabel = isSameLevel ? "Regresar" : currentParams.label;
				return (
					<Fragment key={`${gIndex}${label}`}>
						{shouldRenderButton(currentDisplayedForm, level, formLevel, gIndex) && (
							<Grid item xs={12} sm={12}>
								<ButtonWithStyle onClick={() => handleCurrentDisplayForm(level, isSameLevel)}>
									{buttonLabel}
								</ButtonWithStyle>
							</Grid>
						)}
						{shouldRenderInput(currentDisplayedForm, level, formLevel, gIndex) && (
							<QuestionContainer
								formLevel={level}
								currentDisplayedForm={currentDisplayedForm}
								handleChange={(e) => localHandleChange(e, gIndex, level)}
								handleCurrentDisplayForm={handleCurrentDisplayForm}
								questions={children}
								formData={formCurrentPosition[gIndex]}
								globalFormData={formData}
								handleFormData={handleFormData}
							/>
						)}
					</Fragment>
				);
			})}
			{shouldRenderButton(currentDisplayedForm, {}, formLevel) && (
				<>
					<ButtonWithStyle onClick={increaseParentAmount}>+</ButtonWithStyle>
					<ButtonWithStyle onClick={decreaseParentAmount}>-</ButtonWithStyle>
				</>
			)}
		</>
	);
}
